import script from "./edit.vue?vue&type=script&lang=jsx"
export * from "./edit.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__